export default {
  home: {
    title: 'Главная',
    aiBannerTxt: {
      title: 'Внедрить AI-образование в жизнь',
      subtitle: 'Цифровая трансформация AI+ образования, интеграция инновационных концепций',
      description: 'Фокус на лазерных продуктах и технических услугах, помощь учреждениям и компаниям в интеграции "AI+ Education"'
    },
    description: 'Добро пожаловать на наш маркетинговый сайт на Vue.js',
    banner: {
      slide1: {
        title:
          'Наборы STEAM | Наборы по искусственному интеллекту | Наборы для лазерной резки',
        description:
          'Мы предоставляем инновационные STEAM образовательные решения и наборы для домашних пользователей, педагогов и дистрибьюторов, предназначенные для детей от 3 до 16 лет.',
      },
      slide2: {
        title:
          'Профессиональные наборы, разработанные для развития креативности детей',
        description:
          'Интеграция курсов, оборудования и программного обеспечения для легкого проектного обучения',
      },
      slide3: {
        title: 'Технологическое образование, ориентированное на будущее',
        description:
          'Практическая работа, междисциплинарное обучение, развитие навыков решения проблем и командной работы',
      },
    },
    factory: {
      banner: {
        alt: 'Баннер интеллектуальной фабрики',
        title: 'Решения для интеллектуальной фабрики',
        description:
          'Создание производственных линий | Промышленные датчики | PLC управление и сбор данных',
        image: 'https://picsum.photos/seed/factory-banner/1000/600',
      },
      resourcesTitle: 'Учебные материалы',
      resources: [
        {
          title: 'Материалы проектного обучения',
          desc: 'Презентации и раздаточные материалы, дизайн и рекомендации по оценке учебных мероприятий.',
          image: 'https://picsum.photos/seed/factory-res-1/374/217',
        },
        {
          title: 'Примеры сценариев и ресурсы',
          desc: 'Примеры управления конвейерными лентами, проверки рабочих мест, взаимодействия оборудования и фрагменты кода.',
          image: 'https://picsum.photos/seed/factory-res-2/374/217',
        },
        {
          title: 'Задания для расширенного изучения',
          desc: 'Дополнительные задания и рекомендации по междисциплинарному применению для стимулирования исследований и творчества.',
          image: 'https://picsum.photos/seed/factory-res-3/374/217',
        },
      ],
      intro: {
        title: 'Описание продукта',
        desc: 'Решение для интеллектуальной фабрики сосредоточено на создании производственных линий и программном управлении, охватывает промышленные датчики, распознавание рабочих мест, управление PLC/микроконтроллерами и сбор данных, акцентируя внимание на практике и систематическом обучении.',
        bg: 'https://picsum.photos/seed/factory-bg/1200/736',
      },
      course: {
        title: 'Сопутствующие курсы',
        desc: 'Проектные курсы, посвящённые созданию производственных линий, промышленным датчикам, управлению PLC и сбору данных, с акцентом на практику и системное обучение.',
        image: 'https://picsum.photos/seed/factory-course/668/597',
      },
      equipments: [
        {
          title: 'Модуль конвейерной ленты',
          image: 'https://picsum.photos/seed/factory-eq-1/209/209',
        },
        {
          title: 'Фотоэлектрический датчик',
          image: 'https://picsum.photos/seed/factory-eq-2/209/209',
        },
        {
          title: 'PLC контроллер',
          image: 'https://picsum.photos/seed/factory-eq-3/209/209',
        },
        {
          title: 'Модуль роботизированной руки',
          image: 'https://picsum.photos/seed/factory-eq-4/209/209',
        },
        {
          title: 'Модуль распознавания штрих-кодов',
          image: 'https://picsum.photos/seed/factory-eq-5/209/209',
        },
        {
          title: 'Датчик температуры и влажности',
          image: 'https://picsum.photos/seed/factory-eq-6/209/209',
        },
        {
          title: 'Модуль управления двигателем',
          image: 'https://picsum.photos/seed/factory-eq-7/209/209',
        },
        {
          title: 'Модуль проверки рабочих мест',
          image: 'https://picsum.photos/seed/factory-eq-8/209/209',
        },
        {
          title: 'Модуль аварийной остановки',
          image: 'https://picsum.photos/seed/factory-eq-9/209/209',
        },
        {
          title: 'Шлюз сбора данных',
          image: 'https://picsum.photos/seed/factory-eq-10/209/209',
        },
      ],
    },
    solutions: {
      title: 'Образовательные решения Zetok STEAM',
      learnMore: 'Узнать больше >',
      items: [
        {
          image: require('@/assets/home/solution1.webp'),
          title: 'Наборы Zetok',
          description:
            'Через практические занятия и проектное обучение развиваются творческое мышление и практические навыки.',
          link: '/solutions/kits',
        },
        {
          image: require('@/assets/home/solution2.webp'),
          title: 'Good Laser Лазерные резаки и гравёры',
          description:
            'Лазерные резаки предоставляют совершенно новый практический опыт обучения в STEAM.',
          link: '/solutions/laser',
        },
      ],
    },
    scenes: {
      title: 'Образовательные сцены',
      items: [
        {
          image: require('@/assets/home/education1.webp'),
          title: 'Решения для STEM образования',
        },
        {
          image: require('@/assets/home/education2.webp'),
          title: 'Решения для креативных пространств',
        },
      ],
    },
    aiBanner: {
      alt: 'AI Баннер',
      image: require('@/assets/home/aibanner.png'),
    },
    kitsSection: {
      alt: 'Наборы Zetok',
      title: 'Наборы по искусственному интеллекту',
      description:
        'Наборы по искусственному интеллекту обычно включают интерактивные и практические проекты, стимулирующие интерес студентов к технологиям и любопытство.',
      image: require('@/assets/home/kitsbanner.png'),
    },
    kitsCarousel: {
      alt: 'Карусель наборов',
      title: 'Развитие творческого мышления',
      items: [
        { image: require('@/assets/home/kits1.png') },
        { image: require('@/assets/home/kits2.png') },
        { image: require('@/assets/home/kits3.png') },
        { image: require('@/assets/home/kits4.png') },
        { image: require('@/assets/home/kits5.png') },
        { image: require('@/assets/home/kits6.png') },
        { image: require('@/assets/home/kits7.png') },
        { image: require('@/assets/home/kits8.png') },
        { image: require('@/assets/home/kits9.png') },
      ],
    },
    products: {
      title: 'Наборы Zetok и лазерные резаки Good Laser',
      tabs: {
        kits: 'Наборы',
        courses: 'Курсы',
        laser: 'Лазерное оборудование',
        software: 'Программное обеспечение',
      },
      items: {
        kits: [
          {
            image: require('@/assets/home/product1.webp'),
            title: 'Начальный набор для лазерной резки',
            description: '(с комплектом деревянных материалов)',
          },
          {
            image: require('@/assets/home/product2.webp'),
            title: 'Удивительный научный набор',
            description: '(с комплектом деревянных материалов и микросхем)',
          },
          {
            image: require('@/assets/home/product3.webp'),
            title: 'Набор по программированию ИИ',
            description: '',
          },
        ],
        courses: [
          {
            image: require('@/assets/home/product4.webp'),
            title: 'Система научных исследований - дошкольники',
            description: '（6 курсов）',
          },
          {
            image: require('@/assets/home/product5.webp'),
            title: 'Система STEAM для подростков',
            description: '（3 курса）',
          },
          {
            image: require('@/assets/home/product6.webp'),
            title: 'Курсы по лазерной резке',
            description: '（3 курса）',
          },
          {
            image: require('@/assets/home/product7.webp'),
            title: 'Система курсов по ИИ',
            description: '（4 курса）',
          },
        ],
        laser: [
          {
            image: require('@/assets/home/product8.png'),
            title: 'Light 530',
            description: '55 Вт настольный Co2 лазерный резак и гравёр',
          },
          {
            image: require('@/assets/home/product9.png'),
            title: 'Light 640',
            description: 'Профессиональный настольный лазерный резак и гравёр',
          },
          {
            image: require('@/assets/home/product10.png'),
            title: 'Light Blue 530',
            description:
              'Интеллектуальный настольный синий лазерный резак и гравёр',
          },
          {
            image: require('@/assets/home/product11.png'),
            title: 'Mark M20',
            description: 'Высокоточный лазерный маркировщик',
          },
        ],
        software: [
          {
            image: require('@/assets/home/product12.png'),
            title: 'Учебная платформа Zetok',
            description: '',
          },
          {
            image: require('@/assets/home/product13.png'),
            title: 'Облачная платформа Zetok',
            description: '',
          },
          {
            image: require('@/assets/home/product14.png'),
            title: 'Light Maker',
            description: '',
          },
          {
            image: require('@/assets/home/product15.png'),
            title: 'mind+',
            description: '',
          },
          {
            image: require('@/assets/home/product16.png'),
            title: 'Arduino',
            description: '',
          },
        ],
      },
    },
  },
  switch_lang: 'Русский',
  nav: {
    products: 'Продукты',
    smartFarm: 'Умная ферма',
    smartHome: 'Умный дом',
    smartTraffic: 'Умный транспорт',
    smartFactory: 'Интеллектуальная фабрика',
    laserSteam: 'Лазерная резка и STEAM наборы',
    dreamScience: 'Наборы "Мечта науки"',
    course: 'Курсы',
    device: 'Оборудование',
    education: 'Образовательные решения',
    stem: 'Решения STEM образования',
    maker: 'Решения для креативных пространств',
    software: 'Программное обеспечение',
    service: 'Сервис и поддержка',
    afterSale: 'Скачать учебные материалы',
    about: 'О нас',
    aboutUs: 'О нас',
    dealer: 'Стать нашим дистрибьютором',
    cooperation: 'Сотрудничество и использование продуктов в образовании',
    news: 'Новости',
    coursesSeries: 'Четыре серии курсов',
    viewMore: 'Подробнее',
    store: 'Магазин'
  },
  globalContactForm: {
    title: 'Свяжитесь с нами',
    subtitle:
      'Если у вас есть вопросы или потребности, свяжитесь с нами, мы будем рады помочь',
    fields: {
      name: 'Имя',
      email: 'Электронная почта',
      phone: 'Телефон',
      company: 'Компания',
      message: 'Сообщение',
    },
    placeholders: {
      name: 'Введите имя',
      email: 'Введите адрес электронной почты',
      phone: 'Введите номер телефона',
      company: 'Введите название компании',
      message: 'Пожалуйста, напишите ваш запрос или вопрос',
    },
    validation: {
      name: 'Введите имя',
      email: 'Введите адрес электронной почты',
      emailFormat: 'Неверный формат электронной почты',
      phone: 'Введите номер телефона',
      message: 'Пожалуйста, напишите сообщение',
    },
    submit: 'Отправить',
    submitting: 'Отправка…',
    visual: {
      title: 'Профессиональное обслуживание',
      description:
        'Специализация на STEM-образовании для детей 3-16 лет, создание креативных пространств и разработка соответствующих продуктов и курсов.',
    },
    contact: {
      phone: 'Горячая линия',
      email: 'Электронная почта',
    },
  },
  thankYou: {
    metaTitle: 'Спасибо',
    title: 'Спасибо за вашу заявку!',
    description:
      'Мы получили вашу информацию и свяжемся с вами в ближайшее время.',
    seoDescription:
      'Заявка принята. Наша команда свяжется с вами в ближайшее время.',
    backHome: 'На главную',
    browseProducts: 'Просмотреть продукты',
    contactSupport: 'Связаться с поддержкой',
    nextStepsTitle: 'Что будет дальше',
    nextSteps: [
      'Мы рассмотрим вашу заявку в течение 1–2 рабочих дней.',
      'При необходимости мы свяжемся с вами для уточнения деталей.',
      'Вы можете продолжить просмотр сайта или связаться с нами по телефону/электронной почте.',
    ],
    contactTitle: 'Нужна срочная помощь?',
    contactPhoneLabel: 'Служба поддержки:',
    contactEmailLabel: 'E-mail:',
  },
  about: {
    banner: {
      alt: 'Баннер "О нас"',
      title:
        'Zetok сосредоточен на инновационном образовании, предлагая высококачественные наборы и курсы',
      image: require('@/assets/about/banner.png'),
    },
    mission: {
      title: 'Наша миссия',
      desc: 'Наша миссия — использовать передовые технологии искусственного интеллекта для поддержки образования, стимулирования инноваций и подготовки будущих лидеров и инноваторов. Мы верим, что предоставление высококачественных образовательных инструментов и решений помогает студентам и педагогам реализовать свой потенциал.',
      image: require('@/assets/about/mission.png'),
    },
    vision: {
      title: 'Наше видение',
      desc: 'Технологии усиливают образование, обеспечивая каждого студента качественными ресурсами STEM, раскрывая потенциал и формируя будущих инноваторов и лидеров.',
      image: require('@/assets/about/vision.png'),
    },
    products: {
      title: 'Наши продукты',
      tabs: ['Наборы', 'Курсы', 'Лазерное оборудование'],
      items: [
        {
          title: 'Наборы',
          desc: 'Мы предлагаем разнообразные STEM-наборы, включая ИИ, робототехнику, программирование и научные эксперименты. Они продуманы, удобны в использовании и подходят для разных возрастных групп.',
          image: require('@/assets/about/kits.png'),
        },
        {
          title: 'Курсы',
          desc: 'Наши курсы разработаны экспертами и интегрированы с наборами, обеспечивая комплексный образовательный опыт. От базовых концепций до продвинутых применений, подходящих для разных уровней.',
          image: require('@/assets/about/courses.png'),
        },
        {
          title: 'Лазерное оборудование',
          desc: 'Безопасные и удобные в использовании лазерные резаки и гравёры, специально разработанные для образовательной среды. Позволяют студентам воплощать свои идеи в физических объектах.',
          image: require('@/assets/about/laser.png'),
        },
      ],
    },
    dealer: {
      banner: {
        alt: 'Присоединяйтесь к нам как дистрибьютор Zetok',
        title: 'Присоединяйтесь к нам как дистрибьютор Zetok',
        image: require('@/assets/about/dealer.png'),
      },
      intro: {
        title:
          'Откройте новые возможности в образовании и разделите инновации!',
        desc: 'Zetok приглашает вас совместно развивать STEM-образование, предоставляя AI-наборы, лазерное оборудование и стимулируя креативность студентов. Присоединяйтесь и достигайте успеха вместе!',
        image: require('@/assets/about/dealer1.png'),
      },
      mission: {
        title: 'Наша миссия',
        items: [
          {
            title: 'Передовые продукты',
            desc: 'Получите высококачественные инструменты STEAM на рынке.',
            image: require('@/assets/about/dealer-mission-1.png'),
          },
          {
            title: 'Щедрая прибыль',
            desc: 'Выгодные скидки и стимулирующие продажи.',
            image: require('@/assets/about/dealer-mission-2.png'),
          },
          {
            title: 'Поддержка рынка',
            desc: 'Маркетинговые материалы и обучение продажам помогут быстро выйти на рынок.',
            image: require('@/assets/about/dealer-mission-3.png'),
          },
          {
            title: 'Сотрудничество бренда',
            desc: 'Работайте с Zetok, разделяя влияние бренда и ресурсы рынка.',
            image: require('@/assets/about/dealer-mission-4.png'),
          },
        ],
      },
    },
    cooperation: {
      banner: {
        alt: 'Баннер сотрудничества',
        title: 'Сотрудничество по продуктам',
        cta: 'Свяжитесь сейчас',
        ctaLink: '/about#contact',
        image: require('@/assets/about/coop-introbanner.png'),
      },
      intro: {
        title: 'Раскройте потенциал будущих ученых и инженеров',
        desc: 'Присоединяйтесь к нашей программе продвижения STEM-образования и получите специальные предложения и пробные продукты для педагогов. Мы предоставляем инновационные инструменты STEM и эксклюзивные скидки, помогая воспитывать новое поколение инноваторов.',
        image: require('@/assets/about/coop-introbanner1.png'),
      },
      stem: {
        title: 'Действуйте сейчас и откройте новую главу STEM-образования!',
        items: [
          {
            title: 'Бесплатная проба продукта',
            desc: 'Испытайте наши инструменты перед покупкой.',
            image: require('@/assets/about/edu1.png'),
          },
          {
            title: 'Эксклюзивные скидки',
            desc: 'Экономичные решения STEM для вашего класса или школы.',
            image: require('@/assets/about/edu2.png'),
          },
          {
            title: 'Учебные ресурсы',
            desc: 'Предоставление богатых материалов и планов курсов для поддержки обучения.',
            image: require('@/assets/about/edu3.png'),
          },
        ],
      },
      contact: {
        title: 'Свяжитесь с нами',
        desc: 'Если у вас есть вопросы или потребности, свяжитесь с нами, мы будем рады помочь',
        image: require('@/assets/about/kites.png'),
      },
    },
    news: {
      banner: {
        alt: 'Баннер новостей',
        title: 'Новости',
        image: require('@/assets/about/newsbanner.png'),
      },
      title: 'Новости',
      tabs: [
        { key: 'company', label: 'Новости компании' },
        { key: 'industry', label: 'Новости отрасли' },
        { key: 'expo', label: 'Новости выставок' },
      ],
      data: {
        company: [
          {
            id: 'company-1',
            title: 'Zetok запускает новый AI набор для классов',
            date: '2025-04-22',
            image: 'https://picsum.photos/seed/news-company-1-zh/560/342',
          },
          {
            id: 'company-2',
            title: 'Сотрудничество со школами для пилотного проекта STEM',
            date: '2025-04-30',
            image: 'https://picsum.photos/seed/news-company-2-zh/560/342',
          },
        ],
        industry: [
          {
            id: 'industry-1',
            title: 'Развитие STEM образования в России',
            date: '2025-05-05',
            image: 'https://picsum.photos/seed/news-industry-1-zh/560/342',
          },
          {
            id: 'industry-2',
            title: 'Новые тенденции в использовании AI наборов в школах',
            date: '2025-05-12',
            image: 'https://picsum.photos/seed/news-industry-2-zh/560/342',
          },
        ],
        expo: [
          {
            id: 'expo-1',
            title: 'Zetok участвует в международной выставке образования 2025',
            date: '2025-06-01',
            image: 'https://picsum.photos/seed/news-expo-1-zh/560/342',
          },
        ],
      },
      viewMore: 'Посмотреть больше',
    },
  },

  finance: {
    contact: {
      success: 'Отправлено успешно, мы свяжемся с вами в ближайшее время',
      error: 'Не удалось отправить, попробуйте позже',
      networkError: 'Сетевая ошибка, проверьте соединение и попробуйте снова',
    },
  },
  footer: {
    subscribePlaceholder: 'Ваш номер телефона или адрес электронной почты',
    subscribe: 'Подписаться',
    subscribeSuccess: 'Подписка успешно оформлена',
    contact: {
      sales: 'Горячая линия продаж: +86 18379276683',
      service: 'Горячая линия обслуживания: +86 400 968 0598',
      email: 'Электронная почта: sam@zz-steam.com',
      address:
        'Адрес: г. Шэньчжэнь, район Футянь, улица Багуа 4, здание Хуашэнда, корпус A',
    },
    icp: 'Политика конфиденциальности · Пользовательское соглашение © Zhongze Education (Shenzhen) Co., Ltd. ICP № 2024289240-3',
  },
  solutions: {
    stem: {
      banner: {
        alt: 'Баннер решения STEM образования',
        title: 'Креативное лидерство в STEM образовании',
        description:
          'Для K12 мы сосредоточены на креативном STEM-образовании, стимулируем любознательность, развиваем логическое мышление и интерес к программированию.',
        image: require('@/assets/solution/banner.png'),
      },
      intro: {
        title: 'Искусственный интеллект и образование в программировании',
        items: [
          {
            icon: require('@/assets/solution/icon1.png'),
            title: 'Просто учиться и использовать',
            description:
              'Графическое программирование, новички быстро осваивают, легко создавать собственные AI-проекты.',
          },
          {
            icon: require('@/assets/solution/icon2.png'),
            title: 'Мощные функции',
            description:
              'Интеллектуальное оборудование, голосовое взаимодействие, безграничные возможности для творчества.',
          },
          {
            icon: require('@/assets/solution/icon3.png'),
            title: 'Широкие возможности расширения',
            description:
              'Подключение аппаратных компонентов, стимулирует воображение и создает безграничные возможности.',
          },
          {
            icon: require('@/assets/solution/icon4.png'),
            title: 'Богатые курсы',
            description:
              'Комплектные курсы, от базового до практического, помогают студентам строить систему знаний.',
          },
        ],
      },
      scenes: {
        title: 'Узнайте о наших специализированных курсах',
        items: [
          {
            tab: 'Школьное образование',
            title: 'AI школьное образование',
            desc: 'Использование AI-наборов для создания интеллектуального голосового ассистента, стимулирует интерес, развивает логическое мышление и навыки программирования, позволяет почувствовать возможности искусственного интеллекта.',
            image: require('@/assets/solution/tc1.png'),
          },
          {
            tab: 'Подготовка к соревнованиям',
            title: 'Подготовка к соревнованиям',
            desc: 'Интеллектуальные наборы помогают в робототехнических конкурсах и научно-технических инновациях, студенты разрабатывают умные проекты, улучшая навыки сотрудничества и креативности.',
            image: require('@/assets/solution/tc2.png'),
          },
          {
            tab: 'Домашнее обучение',
            title: 'Домашнее обучение',
            desc: 'Совместное обучение детей и родителей AI-проектам, развивает практические навыки, укрепляет отношения и повышает технологическую грамотность.',
            image: require('@/assets/solution/tc3.png'),
          },
        ],
      },
      split: {
        title: 'AI + образование: открываем новую эпоху умного обучения',
        desc: 'Использование технологий искусственного интеллекта для персонализированного обучения, точного преподавания, чтобы каждый студент мог свободно погружаться в мир знаний.',
        image: require('@/assets/solution/banner1.png'),
      },
      kits: {
        title: 'Серия STEM наборов',
        images: [
          require('@/assets/solution/kits1.png'),
          require('@/assets/solution/kits2.png'),
          require('@/assets/solution/kits3.png'),
          require('@/assets/solution/kits4.png'),
        ],
      },
    },
    makerSpace: {
      banner: {
        alt: 'Баннер решения Maker Space',
        title: 'Исследуйте наш Maker Space',
        description:
          'В Maker Space образование сочетается с инновационными технологиями, предоставляя студентам платформу для практики и исследований.',
        image: require('@/assets/solution/spacebanner.png'),
      },
      intro: {
        title: 'Полный набор навыков Maker',
        items: [
          {
            icon: require('@/assets/solution/icon5.png'),
            title: 'Применение технических инструментов',
            desc: 'Графическое программирование, легкое освоение, новички быстро создают AI-проекты.',
          },
          {
            icon: require('@/assets/solution/icon6.png'),
            title: 'Открытость и гибкость',
            desc: 'Maker Space — свобода исследований, персональный парк для реализации креативных идей.',
          },
          {
            icon: require('@/assets/solution/icon7.png'),
            title: 'Практическая работа',
            desc: 'Практические занятия, создание, эксперименты и исследования — начало учебного путешествия.',
          },
          {
            icon: require('@/assets/solution/icon8.png'),
            title: 'Командное обучение',
            desc: 'Поощрение сотрудничества в командах, развитие навыков коммуникации и совместной работы.',
          },
        ],
      },
      scenes: {
        title: 'Применение Maker Space',
        items: [
          {
            tab: 'Школьные творческие курсы',
            title: 'Школьные творческие курсы',
            desc: 'Эффективное дополнение к курсам ручного труда, искусства и дизайна.',
            image: require('@/assets/solution/tc4.png'),
          },
          {
            tab: 'Клубы практических исследований',
            title: 'Клубы практических исследований',
            desc: 'Предоставление практической платформы для школьных инновационных клубов.',
            image: require('@/assets/solution/tc5.png'),
          },
          {
            tab: 'Образовательные лаборатории',
            title: 'Образовательные лаборатории',
            desc: 'Подходит для школ, университетов или лабораторий, обновляет учебную среду и предоставляет студентам профессиональные лазерные гравёры.',
            image: require('@/assets/solution/tc6.png'),
          },
        ],
      },
      split: {
        title: 'Инструменты для реализации креативных идей',
        desc: 'Используя точные возможности лазерной резки и интеллектуальные функции взаимодействия программируемых роботов, студенты могут превращать абстрактные идеи в конкретные объекты.',
        image: require('@/assets/solution/banner2.png'),
      },
      kits: {
        title: 'Серия Maker наборов',
        images: [
          require('@/assets/solution/kits5.png'),
          require('@/assets/solution/kits6.png'),
          require('@/assets/solution/kits7.png'),
          require('@/assets/solution/kits8.png'),
        ],
      },
    },
  },
  software: {
    banner: {
      alt: 'Баннер страницы программного обеспечения',
      title: 'Центр программного обеспечения Zetok',
      image: require('@/assets/software/banner.png'),
    },
    download: {
      title: 'Скачать программное обеспечение',
      items: [
        {
          key: 'lightmaker-app',
          icon: 'https://picsum.photos/seed/sw-app-1/88/88',
          name: 'Light maker App',
          buttonText: 'Скачать мобильное приложение',
          link: '#',
        },
        {
          key: 'goodlaser-lightmaker',
          icon: 'https://picsum.photos/seed/sw-app-2/88/88',
          name: 'Good-laser Light maker',
          buttonText: 'Скачать клиентское приложение',
          link: '#',
        },
        {
          key: 'zz-learning-app',
          icon: 'https://picsum.photos/seed/sw-app-3/88/88',
          name: 'Приложение учебной платформы Zhongze',
          buttonText: 'Скачать мобильное приложение',
          link: '#',
        },
        {
          key: 'zz-learning-platform',
          icon: 'https://picsum.photos/seed/sw-app-4/88/88',
          name: 'Учебная платформа Zhongze',
          buttonText: 'Скачать клиентское приложение',
          link: '#',
        },
      ],
    },
    intro: {
      'goodlaser-lightmaker': {
        header: {
          title:
            'Light Maker — программное обеспечение для лазерного оборудования',
          desc: 'Объединяет графический дизайн и управление устройствами, экономит время пользователей, предлагая интегрированное решение для дизайна и управления лазером.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-1/514/403',
            title: 'Мощная и удобная система дизайна',
            desc: 'Мощное программное обеспечение для творчества, поддерживает форматы JPG, DXF, AI, DST, PNG, BMP, TIF, SVG.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-2/514/403',
            title: 'Профессионализм',
            desc: 'Профессиональные функции рисования удовлетворяют любые потребности. Сложные и простые проекты легко выполнять.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-3/514/403',
            title: 'Простота использования',
            desc: 'Дружественный интерфейс, поддержка множества лазерных устройств, удобный и многофункциональный интерфейс, эффективная обработка резки и гравировки.',
          },
        ],
      },

      'lightmaker-app': {
        header: {
          title:
            'Light Maker — программное обеспечение для лазерного оборудования',
          desc: 'Объединяет графический дизайн и управление устройствами, экономит время пользователей, предлагая интегрированное решение для дизайна и управления лазером.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-1/514/403',
            title: 'Мощная и удобная система дизайна',
            desc: 'Мощное программное обеспечение для творчества, поддерживает форматы JPG, DXF, AI, DST, PNG, BMP, TIF, SVG.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-2/514/403',
            title: 'Профессионализм',
            desc: 'Профессиональные функции рисования удовлетворяют любые потребности. Сложные и простые проекты легко выполнять.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-3/514/403',
            title: 'Простота использования',
            desc: 'Дружественный интерфейс, поддержка множества лазерных устройств, удобный и многофункциональный интерфейс, эффективная обработка резки и гравировки.',
          },
        ],
      },
      'zz-learning-app': {
        header: {
          title: 'Облачная платформа Zetok',
          desc: 'Облачная платформа — инновационный инструмент управления образованием, предоставляющий учителям, студентам и школам единое решение для управления заданиями, мониторинга устройств, обслуживания и настройки параметров.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-app-1/514/403',
            title: 'Удобство в работе',
            desc: 'Одно нажатие: встроенные библиотеки и конфигурации параметров позволяют быстро создавать проекты. Мониторинг устройств: отслеживание состояния устройств в реальном времени для бесперебойного обучения.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-app-2/514/403',
            title: 'Единое управление',
            desc: 'Параллельное подключение устройств Maker Classroom, функция управления одним кликом повышает эффективность.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-app-3/514/403',
            title: 'Мониторинг в реальном времени',
            desc: 'Статус устройств: мониторинг в реальном времени, своевременное устранение неполадок. Обслуживание: система напоминает о необходимости обслуживания, продлевает срок службы оборудования и улучшает качество резки.',
          },
        ],
      },
      'zz-learning-platform': {
        header: {
          title: 'Образовательная платформа Zetok',
          desc: 'Образовательная платформа Zetok — это инновационный онлайн-инструмент, предназначенный для предоставления студентам и преподавателям комплексного программного решения в области науки и образования. Пользователи могут легко получить доступ и использовать нашу платформу как на мобильных устройствах, так и на компьютерах.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-1/514/403',
            title: 'Интеллектуально и удобно, легко для новичков',
            desc: 'Встроенные библиотеки и предустановленные параметры, поддержка одного клика для быстрого освоения новичками. Подробные инструкции для новичков, облачная поддержка мониторинга устройств в классе, обеспечивая безопасное и эффективное обучение.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-2/514/403',
            title: 'AI творчество',
            desc: 'Функции одного клика и AI генерации изображений упрощают процесс дизайна и повышают эффективность. Пользователи вводят простые команды или загружают образцы, AI генерирует качественные материалы для резки.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-3/514/403',
            title: 'Эффективное обучение',
            desc: 'Платформа Zetok объединяет изучение курсов, графический дизайн и лазерную резку, простой в использовании интерфейс. Главная страница с карточками, чёткое разделение модулей для обучения, дизайна и обработки, улучшает эффективность.',
          },
        ],
      },
    },
  },

  product: {
    farm: {
      banner: {
        alt: 'Баннер умной фермы',
        title: 'Набор для изучения умной фермы',
        btnText: 'Купить сейчас',
        description:
          'Проектное обучение | Программирование + Аппаратное обеспечение + ИИ | Подходит для начальной и средней школы',
        image: require('@/assets/product/farm/banner.png'),
      },
      sections: {
        courseTitle: 'Содержание курса',
        resourceTitle: 'Учебные материалы',
        equipmentsTitle: 'Комплект оборудования',
      },
      courses: [
        {
          bg: '#FBBC05',
          txt: '#fff',
          title: 'Разнообразное содержание курса',
          desc: '12 уроков от простого к сложному: от контроля температуры до умного орошения и управления температурой, полный путь обучения.',
          image: require('@/assets/product/farm/education1.png'),
        },
        {
          bg: '#4285F4',
          txt: '#fff',
          title: 'Интеграция междисциплинарных знаний',
          desc: 'Каждый проект включает программирование, электронное оборудование, механическую конструкцию и другие дисциплины, что помогает учащимся применять знания на практике и развивать междисциплинарное мышление.',
          image: require('@/assets/product/farm/education2.png'),
        },
        {
          bg: '#EA4335',
          txt: '#fff',
          title: 'Тематика, близкая к жизни',
          desc: 'Тема умной фермы приближена к повседневной жизни студентов, легко вызывает интерес и мотивирует к участию.',
          image: require('@/assets/product/farm/education3.png'),
        },
      ],
      resources: [
        {
          title: 'Полные учебные PPT и раздаточные материалы',
          desc: 'Учебные PPT и раздаточные материалы по 16 занятиям, тесно соответствующие проектам, обеспечивают преподавателям богатый учебный материал и уменьшают нагрузку на подготовку.',
          image: require('@/assets/product/farm/edu1.png'),
        },
        {
          title: 'Видео сборки проектных курсов',
          desc: 'Видео материалы наглядно показывают процесс сборки проектов, помогают студентам лучше понять и освоить последовательность действий, повышая эффективность обучения.',
          image: require('@/assets/product/farm/edu2.png'),
        },
        {
          title: 'Вспомогательные учебные материалы',
          desc: 'Раздаточные материалы и другие вспомогательные ресурсы предоставляют студентам подробное руководство, удобное для повторения и самостоятельного изучения.',
          image: require('@/assets/product/farm/edu3.png'),
        },
      ],
      equipments: [
        {
          title: 'RGB светодиодная лента',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Часы DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Датчик температуры и влажности DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Датчик движения',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Светодиодный модуль',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Вентилятор',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Оптопара в пазу',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Модуль кнопок',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Контроллер',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Расширенный набор',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },

    home: {
      banner: {
        alt: 'Баннер умного дома',
        title: 'Набор для изучения умного дома',
        btnText: 'Купить сейчас',
        description:
          'Программирование и ИИ для начинающих | Проектное обучение | Лучший выбор для уроков науки в школе',
        image: require('@/assets/product/home/banner.png'),
      },
      resourcesTitle: 'Преимущества набора для изучения умного дома',
      resources: [
        {
          title: 'Богатые ресурсы',
          desc: 'Предоставляются полные учебные материалы для удобства преподавателей и студентов.',
          image: require('@/assets/product/home/adv1.png'),
        },
        {
          title: 'Междисциплинарная интеграция',
          desc: 'Каждый проект включает программирование, электронику, механику и другие дисциплины, что помогает учащимся применять знания на практике.',
          image: require('@/assets/product/home/adv2.png'),
        },
        {
          title: 'Дополнительные задания',
          desc: 'Расширенные задания и рекомендации по междисциплинарному применению способствуют исследованию и творчеству.',
          image: require('@/assets/product/home/adv3.png'),
        },
      ],
      course: {
        title: 'Сопутствующие курсы',
        desc: 'Содержит 12 высококачественных проектных курсов, охватывающих различные аспекты умного дома, такие как электронный дверной звонок, светильник с регулировкой яркости, гараж с датчиком движения, парольный замок, газовая сигнализация, сигнализация от взлома, декоративные светильники, музыкальное освещение, контроль солнечного света, контроль температуры и вентилятор.',
        image: require('@/assets/product/home/banner2.png'),
      },
      scenesTitle: 'Различные сценарии применения',
      scenes: [
        {
          title: 'Классное обучение',
          image: require('@/assets/product/home/c1.png'),
        },
        {
          title: 'Самостоятельная разработка',
          image: require('@/assets/product/home/c2.png'),
        },
        {
          title: 'Семейное взаимодействие',
          image: require('@/assets/product/home/c3.png'),
        },
        {
          title: 'Демонстрация проектов',
          image: require('@/assets/product/home/c4.png'),
        },
      ],
      equipmentsTitle: 'Комплект оборудования',
      equipments: [
        {
          title: 'RGB светодиодная лента',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Часы DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Датчик температуры и влажности DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Датчик движения',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Светодиодный модуль',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Вентилятор',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Оптопара в пазу',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Модуль кнопок',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Контроллер',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Расширенный набор',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },

    factory: {
      banner: {
        alt: 'Баннер умной фабрики',
        title: 'Набор для изучения умной фабрики',
        btnText: 'Купить сейчас',
        description: `· Полный охват сенсоров, управления и приводов <br> · Симуляция реальной производственной линии <br> · Формирование "инженеров будущего"`,
        image: require('@/assets/product/factory/banner.png'),
      },
      resourcesTitle: 'Особенности продукта',
      resources: [
        {
          title: 'Опыт Индустрии 4.0',
          desc: 'Студенты практикуются с сенсорами, управлением, приводами и управлением данными на симулированной линии.',
          image: require('@/assets/product/factory/tc1.png'),
        },
        {
          title: 'Проектное обучение',
          desc: 'Включает учебники по программированию и 12 уроков с PPT, удобных для изучения.',
          image: require('@/assets/product/factory/tc2.png'),
        },
        {
          title: 'Симуляция реальных условий',
          desc: 'Умный робот-манипулятор, автоматическая сортировка, интеллектуальный склад моделируют управление логистикой, открывая путь к STEM практикам.',
          image: require('@/assets/product/factory/tc3.png'),
        },
      ],
      intro: {
        title: 'Описание продукта',
        desc: 'Набор для изучения умной фабрики сочетает программирование, электронное оборудование, механическую конструкцию, лазерную резку и обучение ИИ. Подходит для школьников и преподавателей. Тематика: "Умное производство·Создавай будущее". Моделируя производственную среду, развивает научное исследование, инженерный дизайн, программирование и командное взаимодействие.',
        bg: require('@/assets/product/factory/product.png'),
      },
      course: {
        title: 'Сопутствующие курсы',
        desc: '12 высококачественных курсов: введение в умную фабрику, производственный процесс, применение сенсоров, основы механического привода, сборка транспортной системы, автоматическая сортировка, координация рабочих станций, сборка робота-манипулятора, интеллектуальная сортировка и сбор данных. Курс проектный, с упором на практику и системное обучение.',
        image: require('@/assets/product/factory/course.png'),
      },
      equipmentsTitle: 'Комплект оборудования',
      equipments: [
        {
          title: 'RGB светодиодная лента',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Часы DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Датчик температуры и влажности DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Датчик движения',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Светодиодный модуль',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Вентилятор',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Оптопара в пазу',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Модуль кнопок',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Контроллер',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Расширенный набор',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },

    kits: {
      laserSteam: {
        banner: {
          alt: 'Баннер STEAM набора для лазерной резки',
          title: 'STEAM набор для лазерной резки',
          btnText: 'Купить сейчас',
          description:
            'Комплексное решение для развития творческого мышления и командной работы',
          image: require('@/assets/product/laser-steam/banner.png'),
        },
        resourcesTitle: 'Преимущества STEAM набора для лазерной резки',
        resources: [
          {
            title: 'Теория множественного интеллекта',
            desc: 'Курсы развивают креативность, критическое мышление, навыки решения проблем и командное взаимодействие.',
            image: require('@/assets/product/laser-steam/adv1.png'),
          },
          {
            title: 'Проектное обучение',
            desc: 'Ученики обучаются на практике, повышая эффективность и интерес к занятиям.',
            image: require('@/assets/product/laser-steam/adv2.png'),
          },
          {
            title: 'STEAM образование',
            desc: 'Содержимое курса объединяет науку, технологии, инженерию, искусство и математику, способствуя междисциплинарному мышлению.',
            image: require('@/assets/product/laser-steam/adv3.png'),
          },
        ],
        teach: {
          title: 'Подробное обучение',
          tabs: [
            { key: 'cutter', label: 'Лазерный резак' },
            { key: 'lesson', label: 'Сопутствующие курсы' },
            { key: 'material', label: 'Учебные материалы' },
            { key: 'software', label: 'Программное обеспечение' },
          ],
          images: {
            cutter: require('@/assets/product/laser-steam/cutter.png'),
            lesson: require('@/assets/product/laser-steam/lesson.png'),
            material: require('@/assets/product/laser-steam/material.png'),
            software: require('@/assets/product/laser-steam/software.png'),
          },
        },
        aiBanner: {
          title: 'ИИ‑образование, умный старт',
          desc: 'Совмещаем STEAM‑образование с элементами ИИ, создаём всесторонний учебный опыт.',
        },
        equipmentsTitle: 'Комплект оборудования',
      },
      dreamScience: {
        banner: {
          alt: 'Баннер набора Dream Science',
          title: 'Удивительный научный набор (Dream Science Kit)',
          description:
            'Научное мышление | Исследования | Практическое обучение | Ответственность',
          image: require('@/assets/product/dream-science/banner.png'),
        },
        resourcesTitle: 'Содержание набора',
        resources: [
          {
            title: 'Материалы для научных экспериментов',
            desc: 'Используются для различных экспериментов и проектов.',
            image: require('@/assets/product/dream-science/kits1.png'),
          },
          {
            title: 'Учебные материалы',
            desc: 'Включает PPT и раздаточные материалы на один семестр, соответствующие проектам и темам.',
            image: require('@/assets/product/dream-science/kits2.png'),
          },
          {
            title: 'Видео сборки и раздаточные материалы',
            desc: 'Помогают учащимся понять и освоить последовательность действий.',
            image: require('@/assets/product/dream-science/kits3.png'),
          },
        ],
        objectivesTitle: 'Цели обучения',
        objectives: [
          {
            title: 'Научные исследовательские навыки',
            desc: 'Формулировка вопросов, планирование, сбор и анализ данных',
            image: require('@/assets/product/dream-science/education1.png'),
          },
          {
            title: 'Инженерные практические навыки',
            desc: 'Сборка, тестирование, итеративное улучшение решений',
            image: require('@/assets/product/dream-science/education2.png'),
          },
          {
            title: 'Междисциплинарная интеграция',
            desc: 'Объединение математики, физики и искусства для выполнения проектов',
            image: require('@/assets/product/dream-science/education3.png'),
          },
        ],
        intro: {
          title: 'Целевая аудитория',
          description:
            'Школьники: подходят для разных возрастных групп, способствуют развитию научной грамотности и практических навыков. Учителя: предоставляют учебные материалы и рекомендации для эффективного обучения.',
          image: require('@/assets/product/dream-science/banner1.png'),
          alt: 'Изображение блока информации',
        },
      },
    },

    kitsViewAll: {
      banner: {
        alt: 'Баннер всех наборов',
        title: 'Серия наборов',
        image: require('@/assets/product/kitsall/banner.png'),
      },
      contentTitle:
        'Основное внимание на проекте: студенты развивают навыки комплексного применения знаний для решения задач.',
      moreText: 'Узнать больше',
      items: [
        {
          image: require('@/assets/product/kitsall/kits1.png'),
          title: 'Набор для изучения умной фермы',
          desc: 'Проектная ориентация стимулирует креативность и практические навыки студентов.',
          link: '/products/laser-steam',
        },
        {
          image: require('@/assets/product/kitsall/kits2-1.png'),
          title: 'Набор для изучения умного дома',
          desc: 'Объединяет программирование, электронику, механику, лазерную резку и ИИ, обеспечивая полный опыт обучения.',
          link: '/products/dream-science',
        },
        {
          image: require('@/assets/product/kitsall/kits2-2.png'),
          title: 'Набор для изучения умного транспорта',
          desc: 'Проектно-ориентированный набор с программированием, электроникой, механикой, лазерной резкой и ИИ.',
          link: '/products',
        },
        {
          image: require('@/assets/product/kitsall/kits2-3.png'),
          title: 'Набор для изучения умной фабрики',
          desc: 'Включает базовые знания ИИ и практические примеры, поэтапно обучая студентов.',
          link: '/products/traffic',
        },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: 'STEAM набор для лазерной резки',
        //   desc: 'Основан на теории множественного интеллекта, STEAM-образовании и проектной методике.',
        //   link: '/products/home',
        // },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: 'Dream Science Kit',
        //   desc: 'Соответствует разным уровням обучения, стимулирует интерес к науке и исследовательский дух.',
        //   link: '/products/farm',
        // },
      ],
    },

    traffic: {
      banner: {
        alt: 'Баннер умного транспорта',
        title: 'Набор для изучения умного транспорта',
        btnText: 'Купить сейчас',
        description: `12 проектных курсов 
  <br>· Графическое/Python двойное программирование  <br>
 · Симуляция реальных сценариев<br>
 · Мгновенное обучение`,
        image: require('@/assets/product/traffic/banner.png'),
      },
      resourcesTitle: 'Особенности продукта',
      resources: [
        {
          title: 'Научные исследования и инновации',
          desc: 'Студенты создают системы умного транспорта, используя электронные модули и механические конструкции',
          image: require('@/assets/product/traffic/traffic1.png'),
        },
        {
          title: 'Высокая образовательная ценность',
          desc: 'Можно строить умные уличные фонари, светофоры, пешеходные переходы и парковки, что помогает учащимся понять концепцию умного транспорта.',
          image: require('@/assets/product/traffic/traffic2.png'),
        },
        {
          title: 'Богатый ресурсный комплект',
          desc: 'Полный комплект учебных материалов, включая PPT и раздаточные материалы на 12 уроков, видео сборки проектных курсов и дополнительные материалы.',
          image: require('@/assets/product/traffic/traffic3.png'),
        },
      ],
      intro: {
        title: 'Описание продукта',
        desc: 'Набор для изучения умного транспорта для школ нацелен на темы "умное передвижение" и "дорожная безопасность". Он сочетает технологии электронного управления и датчиков, направляя студентов на самостоятельное проектирование и сборку систем умного транспорта, моделируя реальные дорожные ситуации, развивая научную грамотность и инновационные способности.',
        bg: require('@/assets/product/traffic/banner1.png'),
      },
      course: {
        title: 'Сопутствующие курсы',
        desc: 'Включает проектные курсы по основам восприятия и управления транспортом, координации сигналов, планированию маршрутов и другим темам, адаптированные под разные уровни и расписания занятий.',
        image: require('@/assets/product/traffic/course.png'),
      },
      equipmentsTitle: 'Комплект оборудования',
      equipments: [
        {
          title: 'RGB светодиодная лента',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Модуль часов DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Датчик температуры и влажности DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Датчик движения',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Светодиодный модуль',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Вентилятор',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Оптопара в пазу',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Модуль кнопок',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Контроллер',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Расширенный комплект',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    banner: {
      alt: 'Баннер главной страницы продуктов',
      title: 'Продукты и решения Zetok',
      description:
        'Комплекты, курсы, оборудование и ПО в одном наборе, поддержка проектного обучения',
      image: 'https://picsum.photos/id/1069/1600/900',
    },
    courses: {
      banner: {
        alt: 'Баннер курсов',
        title: 'Четыре основных курса',
        description:
          'Содержание курсов охватывает науку, технологии, инженерию, искусство и математику (STEAM), способствуя интеграции и применению междисциплинарных знаний.',
        image: require('@/assets/product/courses/banner.png'),
      },
      design: {
        title: 'Изучите наши специализированные курсы',
        nav: [
          'Возраст 3-6 лет',
          'Возраст 6-12 лет',
          'Возраст 8-13 лет',
          'Возраст 9-15 лет',
        ],
        entries: [
          {
            title: 'Система научных исследований для детей (6 курсов)',
            desc: 'Исследование обычных явлений в повседневной жизни с помощью научных пособий, чтобы понять закономерности и принципы развития вещей.',
            image: require('@/assets/product/courses/courses1.png'),
          },
          {
            title: 'Система STEAM/Мейкер для подростков (3 курса)',
            desc: 'Развивайте собственные идеи, используйте оборудование, превращайте творчество в реальные проекты.',
            image: require('@/assets/product/courses/courses2.png'),
          },
          {
            title: 'Курс по лазерной резке (3 курса)',
            desc: 'Использование оборудования для резки различных конструкционных элементов, сборка в трехмерные конструкции и их украшение. Программирование: понимание логики и принципов программирования.',
            image: require('@/assets/product/courses/courses3.png'),
          },
          {
            title: 'Курс по искусственному интеллекту (4 курса)',
            desc: 'Использование оборудования для дизайна внешнего вида проектов, программирование для придания проектам интеллектуальных функций и решения реальных проблем.',
            image: require('@/assets/product/courses/courses4.png'),
          },
        ],
        detailsTitle: 'Преимущества курсов',
        details: [
          {
            title: 'Практическая направленность',
            description:
              'Практическая деятельность, теория превращается в навыки',
            image: require('@/assets/product/courses/icon1.png'),
          },
          {
            title: 'Развитие творческого мышления',
            description:
              'Практическое проектирование, креативное решение задач',
            image: require('@/assets/product/courses/icon2.png'),
          },
          {
            title: 'Проектное обучение',
            description: 'Обучение через проекты, освоение знаний на практике',
            image: require('@/assets/product/courses/icon3.png'),
          },
          {
            title: 'Исследование передовых технологий',
            description:
              'Следите за новейшими технологиями, изучайте применение интеллектуальных наборов',
            image: require('@/assets/product/courses/icon4.png'),
          },
          {
            title: 'Системное обучение',
            description: 'Курсы от простого к сложному, от теории к практике',
            image: require('@/assets/product/courses/icon5.png'),
          },
          {
            title: 'Баланс интереса и сложности',
            description:
              'Интерес стимулирует, вызов раскрывает потенциал, рост через исследование.',
            image: require('@/assets/product/courses/icon6.png'),
          },
        ],
      },
      ai: {
        title: 'Серия курсов по искусственному интеллекту',
        items: [
          {
            name: 'Умная ферма',
            image: require('@/assets/product/courses/courses5.png'),
          },
          {
            name: 'Умный дом',
            image: require('@/assets/product/courses/courses6.png'),
          },
          {
            name: 'Умный транспорт',
            image: require('@/assets/product/courses/courses7.png'),
          },
          {
            name: 'Умная фабрика',
            image: require('@/assets/product/courses/courses8.png'),
          },
        ],
      },
      aiBanner: {
        alt: 'Баннер AI курсов',
        text: 'Проектное обучение, междисциплинарная интеграция, развитие навыков работы руками, сотрудничества и решения проблем. Безопасность и индивидуальный подход, демонстрация результатов повышает чувство достижения и способствует развитию студентов.',
        image: require('@/assets/product/courses/banner1.png'),
      },
    },

    laser: {
      banner: {
        alt: 'Лазерная продукция',
        title: 'Good Laser Лазерная продукция',
        description:
          'Безопасное и удобное в использовании оборудование и решения для лазерной резки/гравировки в образовательной сфере',
        image: require('@/assets/product/laser/banner.png'),
      },
      advantagesTitle: 'Наши преимущества',
      extraNote: {
        light640_640:
          'Отличные работы по резке и гравировке\nРазличные модели и мощности лазера для разных потребностей\nТип лазера: DC CO2  Мощность лазера: 60W-130W',
      },
      center: {
        title: 'Центр продуктов',
        laser_accessories: 'Аксессуары для лазера',
        air_purifier_name: 'Очиститель воздуха',
        description:
          'Предлагаются решения по комплектации лазерного оборудования. В зависимости от уровня преподавания в школе Zetok предлагает четыре официальные модели лазерного оборудования, которые можно выбрать в соответствии с реальными потребностями обучения.',
        tabs: [
          {
            key: 'light530',
            label: 'Light 530',
            images: [
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Высококачественный и точный лазер',
                bgColor: '#4285F4',
                description:
                  'Утолщённая высококачественная CO2 лазерная трубка, длина волны 10640 нм, обеспечивает высококачественный CO2 лазер мощностью 55 Вт, максимальная толщина резки до 20 мм (акрил), рабочая скорость до 600 мм/с, повторяемая точность позиционирования 0,025 мм. Позволяет быстро и точно вырезать и гравировать изысканные творческие работы.',
                image: require('@/assets/product/laser/light530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Интегрированная система тройной фильтрации выхлопа',
                bgColor: '#FFBC0C',
                description:
                  'Система фильтрации дыма с сеткой, активированным углем и УФ-озоновым слоем, интегрирована в одну конструкцию. Более чисто и экологично, размещение продукта удобное и компактное, нет необходимости покупать отдельный фильтрующий бокс.',
                image: require('@/assets/product/laser/light530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Наивысшие стандарты безопасности',
                bgColor: '#34A853',
                description:
                  'Протестировано по стандартам безопасности SGS, лазер класса I с сертификацией FDA, уникальная система индикаторов состояния работы, позволяющая наглядно контролировать работу машины.',
                image: require('@/assets/product/laser/light530-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title:
                  'Простая в использовании и мощная система лазерной резки',
                bgColor: '#0F9D58',
                description:
                  '· Возможность настройки параметров обработки для разных материалов: резка, глубокая/поверхностная гравировка, сканирование и др. · Богатая библиотека чертежей для повышения эффективности дизайна. · Камера для точного позиционирования, помогает реализовать дизайнерские идеи.',
                image: require('@/assets/product/laser/light530-4.png'),
              },
            ],
          },
          {
            key: 'light640',
            label: 'Light 640',
            images: [
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
            ],
            models: [
              {
                key: '640',
                label: 'Light 640',
                image: require('@/assets/product/laser/640.png'),
              },
              {
                key: '960',
                label: 'Light 960',
                image: require('@/assets/product/laser/960.png'),
              },
              {
                key: '1390',
                label: 'Light 1390',
                image: require('@/assets/product/laser/1390.png'),
              },
              {
                key: '1610',
                label: 'Light 1610',
                image: require('@/assets/product/laser/1610.png'),
              },
            ],
            modelAdvantages: {
              640: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Рабочая зона',
                  bgColor: '#4285F4',
                  description: `Light640 (600*400мм)
Light960 (900*600мм)
<br>Light1390 (1300*900мм)
<br>Light1610(1600*1000мм)`,
                  image: require('@/assets/product/laser/640-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Эффективная автофокусировка + лазерный прицел',
                  bgColor: '#FFBC0C',
                  description:
                    'Функция автофокусировки обеспечивает быструю и точную настройку перед резкой или гравировкой. Лазерный прицел позволяет видеть рабочее положение в реальном времени. Это экономит время и улучшает качество работы.',
                  image: require('@/assets/product/laser/640-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Открытая задняя дверь',
                  bgColor: '#34A853',
                  description:
                    'Позволяет размещать материалы любой длины для резки и гравировки. Размер 600мм x ∞ делает работу удобнее и менее ограниченной.',
                  image: require('@/assets/product/laser/640-3.png'),
                },
              ],
              960: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Отличные работы по резке и гравировке',
                  bgColor: '#4285F4',
                  description:
                    'Широкая платформа лазерной резки обеспечивает корпоративную точность и эффективность при обработке древесины и акрила. Подходит для массового производства лазерных изделий.',
                  image: require('@/assets/product/laser/960-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Высококачественные лазерные трубки и точные компоненты',
                  bgColor: '#FFBC0C',
                  description:
                    'Разнообразие моделей позволяет выбирать различные типы лазеров и скорости обработки, соответствуя производственным требованиям. Возможна обработка дерева, стекла, акрила и др.',
                  image: require('@/assets/product/laser/960-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Строгие тесты качества лазера',
                  bgColor: '#34A853',
                  description:
                    'Пройдя строгие тесты и многократные испытания, CO2 лазер гарантирует стабильный и равномерный световой поток для качественной гравировки сложных деталей.',
                  image: require('@/assets/product/laser/960-3.png'),
                },
              ],
              1390: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Комплексные и передовые функции безопасности',
                  bgColor: '#4285F4',
                  description: `1. Аварийная остановка
<br>2. Сигнальная лампа
<br>3. Водозащищенный переключатель
<br>4. Заземление
<br>5. Встроенный тепловой датчик с сигнализацией при аномальной работе
<br>6. Защитная крышка
<br>7. Прочная стеклянная защитная панель`,
                  image: require('@/assets/product/laser/1390-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Долговечность и высокое качество',
                  bgColor: '#FFBC0C',
                  description: `1. Идеально для единичных проектов или массового производства.
<br>2. Широкий диапазон рабочих зон: от 600x400мм до 1600x1000мм.
<br>3. Непревзойденная скорость гравировки.
<br>4. Разработано экспертами отрасли.
<br>5. Отличный выбор для персонализированного, образовательного и промышленного использования.`,
                  image: require('@/assets/product/laser/1390-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Оптимизация производства через интеллектуальный контроль',
                  bgColor: '#34A853',
                  description:
                    'Защищает чувствительные компоненты оборудования от пыли и загрязнений, обеспечивая многолетнюю безотказную работу даже при интенсивном использовании.',
                  image: require('@/assets/product/laser/1390-3.png'),
                },
              ],
              1610: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Эффективная автофокусировка + лазерный прицел',
                  bgColor: '#4285F4',
                  description:
                    'Функция автофокусировки обеспечивает быструю и точную настройку перед резкой и гравировкой. Лазерный прицел позволяет видеть рабочее положение в реальном времени, экономя время и улучшая качество.',
                  image: require('@/assets/product/laser/1610-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Отличные работы по резке и гравировке',
                  bgColor: '#FFBC0C',
                  description:
                    'Широкая платформа лазерной резки обеспечивает корпоративную точность и эффективность при обработке древесины и акрила, подходя для массового производства.',
                  image: require('@/assets/product/laser/1610-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Долговечность и высокое качество',
                  bgColor: '#34A853',
                  description: `1. Идеально для единичных проектов или массового производства.
<br>2. Широкий диапазон рабочих зон: от 600x400мм до 1600x1000мм.
<br>3. Непревзойденная скорость гравировки.
<br>4. Разработано экспертами отрасли.
<br>5. Отличный выбор для персонализированного, образовательного и промышленного использования.`,
                  image: require('@/assets/product/laser/1610-3.png'),
                },
              ],
            },
          },
          {
            key: 'lightblue530',
            label: 'Light Blue 530',
            images: [
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Портативный синий лазерный гравер',
                bgColor: '#4285F4',
                description:
                  'Синий лазерный гравер стильный, современный, компактный, подходит для дома, школы или студии. Металлический корпус с акриловой крышкой, удобное размещение и мощность 20Вт для резки.',
                image: require('@/assets/product/laser/blue530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Закрытая рабочая зона для безопасности',
                bgColor: '#FFBC0C',
                description:
                  'Полностью закрытый, при открытии крышки процесс автоматически останавливается. В экстренной ситуации один переключатель мгновенно выключает машину. Подходит для дома и школы.',
                image: require('@/assets/product/laser/blue530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Поддержка множества материалов',
                bgColor: '#34A853',
                description:
                  'Можно гравировать сотни материалов, создавать уникальные формы и добавлять аксессуары для расширения возможностей. Отлично подходит для малого бизнеса.',
                image: require('@/assets/product/laser/blue530-3.png'),
              },
            ],
          },
          {
            key: 'markm20',
            label: 'Mark M20',
            images: [
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Многообразие приложений',
                bgColor: '#4285F4',
                description:
                  'Подходит для различных отраслей: ювелирная гравировка, персональные предметы, идентификация деталей, от ювелирных изделий до маленьких промышленных знаков.',
                image: require('@/assets/product/laser/m20.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Инновации в образовании',
                bgColor: '#FFBC0C',
                description:
                  'Привносит промышленную точность в образовательную сферу, развивая навыки от базовой маркировки до сложных проектов.',
                image: require('@/assets/product/laser/m20-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Компактный и современный',
                bgColor: '#34A853',
                description:
                  'Компактный современный дизайн, низкий уровень шума, большое окно, высокая надежность. Соответствует стандартам безопасности.',
                image: require('@/assets/product/laser/m20-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Маркировка за секунды',
                bgColor: '#0F9D58',
                description:
                  'Даже для минимального шрифта маркировка выполняется за секунды. В сочетании с ПО LightMaker это обеспечивает высокую производительность.',
                image: require('@/assets/product/laser/m20-4.png'),
              },
            ],
          },
          {
            key: 'accessories',
            label: 'Аксессуары',
            images: [
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
            ],
            advantages: [
              {
                description: `
                  · Применение: для помещений с дымом, запахом, пылью, токсичными газами.
<br>· Сферы: электроника, игрушки, прецизионная металлообработка, медицина.
<br>· Особенности: односторонний или двухпозиционный дизайн.
<br>· Фильтрация: многослойная.
<br>· Регулировка воздуха: бесступенчатая по объему.
<br>· Эффективность очистки: до 99.97%.
<br>· Выброс воздуха: чистый воздух можно выпускать в помещении.`,
                image: require('@/assets/product/laser/accessories1.png'),
              },
              {
                description: `· Тип оборудования: вспомогательные устройства для лазерной резки/гравировки.
<br>· Назначение: обеспечивает вращение заготовки.
<br>· Для объектов: цилиндрические, трубчатые предметы.
<br>· Расширение: позволяет обрабатывать не только плоские панели, но и цилиндры.`,
                image: require('@/assets/product/laser/accessories2.png'),
              },
              {
                description: `
· Высокоэффективная формовочная машина для точной обработки.
<br>· Управление ЧПУ, простое в эксплуатации.
<br>· Различные формовочные матрицы.
<br>· Быстрая установка заготовок.
<br>· Полная система защиты.
<br>· Для обработки различных материалов.`,
                image: require('@/assets/product/laser/accessories3.png'),
              },
            ],
          },
        ],
      },
    },
  },
  support: {
    afterSales: {
      banner: {
        alt: 'Баннер загрузки учебных материалов',
        title: 'Скачать учебные материалы',
        image: require('@/assets/after/banner.png'),
      },
      downloadText: 'Скачать учебные материалы',
      items: [
        {
          id: 'mk-1',
          name: 'Умная ферма',
          image: 'https://picsum.photos/seed/as-farm1/588/391',
          link: '#',
        },
        {
          id: 'mk-2',
          name: 'Умный дом',
          image: 'https://picsum.photos/seed/as-home1/588/391',
          link: '#',
        },
        {
          id: 'mk-3',
          name: 'Умный транспорт',
          image: 'https://picsum.photos/seed/as-traffic1/588/391',
          link: '#',
        },
        {
          id: 'mk-4',
          name: 'Умная фабрика',
          image: 'https://picsum.photos/seed/as-factory1/588/391',
          link: '#',
        },
        {
          id: 'mk-5',
          name: 'Креативное пространство',
          image: 'https://picsum.photos/seed/as-makerspace1/588/391',
          link: '#',
        },
        {
          id: 'mk-6',
          name: 'Курсы по робототехнике',
          image: 'https://picsum.photos/seed/as-robot1/588/391',
          link: '#',
        },
        {
          id: 'mk-7',
          name: 'AI-курсы',
          image: 'https://picsum.photos/seed/as-ai1/588/391',
          link: '#',
        },
        {
          id: 'mk-8',
          name: 'Курсы по IoT',
          image: 'https://picsum.photos/seed/as-iot1/588/391',
          link: '#',
        },
      ],
    },
  },
};
